<div class="color-wrapper">
  <div>
    <div class="tabs">
      <div class="tab" (click)="switchTab('custom')">
        <button [ngClass]="{ active: currenttab.custom }">Personalizar</button>
      </div>
      <div class="tab" (click)="switchTab('templates')">
        <button [ngClass]="{ active: currenttab.templates }">Plantillas ({{ total_templates }})</button>
      </div>
    </div>

    <div *ngIf="currenttab.custom">
      <app-color-custom
        [custom_colors]="custom_colors"
        (onTemplateCreate)="onCreateTemplate($event)"></app-color-custom>
    </div>
    <div *ngIf="currenttab.templates">
      <app-color-templates
        #templates
        (appliedTemplate)="onApplyTemplate($event)"
        (updatedTemplatesList)="onTemplatesListUpdate($event)"></app-color-templates>
    </div>
  </div>
</div>
